<template>
  <div class="my-20">
    <div class="container grid grid-cols-1 grid-rows-2 sm:grid-rows-1 sm:grid-cols-2 gap-4">
      <FixedAspect v-for="(image, index) in images" :key="index" :ratio="4 / 3" class="w-full">
        <CldnImg
          v-if="image"
          :src="image.url"
          :alt="image.title"
          sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
          class="max-w-none block w-full select-none col-span-1"
        />
      </FixedAspect>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import FixedAspect from '@/components/common/FixedAspect';
import CldnImg from '@/components/CldnImg';

export default defineNuxtComponent({
  name: 'TwoPortraitImages',
  components: { CldnImg, FixedAspect },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
